<template>
    <v-dialog
        v-model="dialog"
        max-width="900"
    >
        <v-card>
            <v-card-title class="headline">
                Send Test Message
            </v-card-title>

            <v-card-text>
                <p>
                    If your message includes variables (like {first-name}),
                    the test message will be customized using information from the recipient: {{recipient_first_name}} {{recipient_last_name}}
                </p>

                <p>
                    Only the phone number you enter below will receive this test message.
                </p>

                <p>
                    Enter the phone number you would like to send a test message to:
                </p>

                <p>
                    <b>Warning to T-Mobile Users</b>:  T-Mobile has known deliverability issues when testing bulk messages.  We suggest you use a cell phone that is on another network.
                    <a
                        v-if="!show_tmobile_details"
                        style="text-decoration: underline"
                        v-on:click="show_tmobile_details = true;"
                    >
                        details
                    </a>
                </p>

                <div
                    v-if="show_tmobile_details"
                >
                <p>
                    When testing bulk messages, it is common to send yourself multiple, similar, messages.  T-Mobile frequently mistakes these messages as a mistake or spam.  
                    When this happens T-Mobile will <b>silently</b> fail to deliver the message.
                    In our experience, this only comes up when <b>testing</b>, it <b>does not</b> effect actual customers because the messages you send to customers are spaced out - typically days or weeks apart.
                </p>

                <p>
                    If you use T-Mobile for testing, then you will, mostly likely, experience situations where no message is delivered.  <i>Sometimes</i> you can fix this (temporarily) 
                    by texting back and forth (conversationally) between your phone and the RedChirp number you will be using to send your bulk message.  This can sometime clue T-Mobile into the
                    fact that this is not a glitch or spam an makes everything work (for a few messages anyway).  <b>This does not always work.</b>
                </p>

                <p>
                    In any event, do not be concerned.  We have examined the data for millions of messages sent and can confirm that, for <b>actual messages</b>, deliverability to T-Mobile is on par with other networks.    
                </p>
                </div>

                <v-list
                >
                    <v-list-item
                        v-for="(item, index) in previous_endpoints"
                        :key="'pun_'+index"
                        v-on:click="onClickEndpoint(item)"
                    >
                            <v-list-item-icon><v-icon>mdi-cellphone</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{item.endpoint_label}}</v-list-item-title>
                                <v-list-item-subtitle>{{$rc.pretty(item.endpoint,'endpoint_no_parens')}}</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action 
                                v-on:click="onClickDeleteEndpoint(item)"
                            >
                                <v-icon>mdi-trash-can-outline</v-icon>
                            </v-list-item-action>
                            
                    </v-list-item>
                    
                </v-list>


                <v-text-field
                    hint="Must be a valid US or CA phone number."
                    v-model="endpoint_value"
                    autofocus
                    autocomplete="off"
                />

                <v-checkbox
                    label="Prepend [test] to the message (makes it clear to recipients that this is a test message)"
                    v-model="prepend_test"
                />

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    text
                    @click="dialog = false;"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                    :disabled="!isValid()"
                >
                    Send
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import E164 from "@/js/E164";

export default {
    data() {
        return {
            endpoint_value: null,
            recipient_id: null,
            recipient_first_name: null,
            recipient_last_name: null,

            show_tmobile_details: false,

            dialog: false,
            prepend_test: false,
            previous_endpoints: [],
        }
    },

    methods: {
        showDialog(recipient_id, recipient_first_name, recipient_last_name)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'LIST: /api/v1/bulk/endpoints-previously-used-to-test',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id
                    },
            
                'on_success': (data) => {
                        this.previous_endpoints = data.results;
                        this.recipient_id = recipient_id;
                        this.recipient_first_name = recipient_first_name;
                        this.recipient_last_name = recipient_last_name;
                        this.prepend_test = false;
                        this.dialog = true;
                    },
            
                'on_error': 'Unable to list previous bulk message recipients',
            });
        },

        onClickDeleteEndpoint(item)
        {
            this.$rc.confirm({
                'title': 'Delete this phone number?',
                'body': 'Delete this phone number?',
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'No',
                'on_ok': () => {
                    this.doDeleteEndpoint(item);
                },
            });
        },

        doDeleteEndpoint(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'DELETE: /api/v1/bulk/endpoints-previously-used-to-test',
            
                'params' : {
                        'organization_id': item.organization_id,
                        'endpoint': item.endpoint,
                    },
            
                'on_success': (data) => {
                        this.previous_endpoints = data.results;
                    },
            
                'on_error': 'Unable to delete previously used phone number',
            });
        },

        onClickEndpoint(item)
        {
            this.endpoint_value = this.$rc.pretty(item.endpoint,'endpoint_no_parens');
        },

        isValid()
        {
            if ( this.endpoint_value == null ) return false;
            if ( !E164.isUSPhoneNumber(this.endpoint_value) ) return false;

            return true;
        },

        onOk() {

            let endpoint = E164.fullEndpoint(this.endpoint_value);

            this.dialog = false;
            this.$emit('send-test-message', this.recipient_id, endpoint, this.prepend_test);
        },

    },
}
</script>